// extracted by mini-css-extract-plugin
module.exports = {"react-international-phone-flag-emoji":"flag-emoji_react-international-phone-flag-emoji__2b2sV"};